import { Repo } from "../apis/repo";
import { RequestData } from "../apis/repo_base";
import {
  GiftAuthMethod,
  GiftBoxSendOtpResponse,
  VerifyOtpResponseV3,
} from "../types/gift";
import { OtpCommunicationMedium } from "../types/auth";
import { RedemptionParams, RedemptionResponse } from "../types/order";

const defaultMockDelayPromise = (ms: number = 2000) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, ms);
  });

export class GiftingMockRepo extends Repo {
  constructor(fetch: <T>(request: RequestData) => Promise<T>) {
    super(fetch);
  }

  async sendGiftOtpV3(params: {
    id: string;
    identifier?: string;
    authMethod?: GiftAuthMethod;
    medium?: OtpCommunicationMedium;
    headers?: Record<string, string>;
  }): Promise<GiftBoxSendOtpResponse> {
    console.table({
      id: params.id,
      identifier: params.identifier,
      medium: params.medium,
      endpoint: `/v3/gifting/gift/${params.id}/auth/send-otp`,
      note: "MOCK: Using GiftingMockRepo",
    });

    await defaultMockDelayPromise();

    return {
      otpToken: "mock-otp-token-" + Date.now(),
      availableMediums: ["SMS", "WHATSAPP"],
    };
  }

  async verifyGiftOtpV3(params: {
    id: string;
    otp: string;
    otpToken: string;
    headers?: Record<string, string>;
  }): Promise<VerifyOtpResponseV3> {
    console.table({
      id: params.id,
      otp: params.otp,
      otpToken: params.otpToken,
      endpoint: `/v3/gifting/gift/${params.id}/auth/verify-otp`,
      note: "MOCK: Using GiftingMockRepo",
    });

    await defaultMockDelayPromise();

    return {
      sessionId: "mock-session-id-" + Date.now(),
    };
  }

  async initiateRedemption(
    params: RedemptionParams,
    headers?: Record<string, string>
  ): Promise<RedemptionResponse> {
    const path = "v2/redemptions/provider/pg/initiate";
    await defaultMockDelayPromise();
    return {
      id: "01JYEAN9CC0136T2V4GMWM9N7K",
      paymentRoute: "PG",
      planType: "BASIC",
      amount: 1000,
      depositPaymentDetails: {
        id: "01JYEAN9WQACPBJ2S3N3Y8ATHJ",
        amount: 0.0,
        status: "SUCCESS",
        provider: "",
        otpToken: "",
        providerMetadata: {
          customerId: "",
          providerOrderId: "",
        },
      },
      storeOrderDetails: {
        id: "01JYEAN9NC3E6PJW86NNA7BQKX",
        amount: 1000,
        status: "PROCESSING",
      },
      refundDetails: {
        id: "",
        amount: 0.0,
        status: "SUCCESS",
      },
    };
  }
}
